import { makeAutoObservable, reaction } from "mobx";
import { ServerError } from "../models/ServerError";

export default class CommonStore {
    error: ServerError | null = null;
    token: string | null = sessionStorage.getItem('gv-pf-base-jwt');
    shopifySession = sessionStorage.getItem('partfits.shopify-session') === 'true';
    sessionRevision = 0;
    appLoaded = false;

    constructor() {
        makeAutoObservable(this);

        // this reaction only runs when token changes
        // this will make the token persist on page refresh/redirects
        reaction(
            () => this.token, 
            token => {
                if (token)
                {
                    sessionStorage.setItem('gv-pf-base-jwt', token);
                } 
                else 
                {
                    sessionStorage.removeItem('gv-pf-base-jwt');
                }
            }
        )
    }
    
    setServerError(error: ServerError) {
        this.error = error;
    }

    setToken = (token : string | null) => {
        if (this.token !== token) this.sessionRevision++;
        this.token = token;
        if (token) {
            this.shopifySession = false;
            sessionStorage.removeItem('partfits.shopify-session');
        }
    }

    useShopifySession = () => {
        this.setToken(null);
        if (!this.shopifySession) this.sessionRevision++;
        this.shopifySession = true;
        sessionStorage.setItem('partfits.shopify-session', 'true');
    }

    invalidateSession = (recoverEmbeddedSession = false) => {
        this.sessionRevision++;
        this.setToken(null);
        if (!recoverEmbeddedSession) {
            this.shopifySession = false;
            sessionStorage.removeItem('partfits.shopify-session');
        }
    }

    setAppLoaded = () => {
        this.appLoaded = true;
    }
   
}
